const { default: axios } = require("axios");

const ExportData = function () {

    const exportData = function (e) {
        e.preventDefault();

        const element = $(this);
        const href = element.attr('href');

        axios.post(href)
            .then(function (response) {
                const data = response.data;

                let classError = "";
                let message = "";
                if (data.error) {
                    classError = 'alert-danger';

                    message = '<ul class="mb-0">';
                    $.each(data.result, function (index, value) {
                        message += '<li>' + value + '</li>';
                    });
                    message += '</ul>';

                } else {
                    classError = 'alert-success';
                    message = data.message;
                }

                $('.card.card-custom').prepend('<div class="alert ' + classError + '">' + message + '</div>');
                setTimeout(() => {
                    $('.card.card-custom .alert').slideUp('slow', function () {
                        $(this).remove();
                    });
                }, 4000);
            });
    }

    return {
        init: function () {
            $(document).on('click', '.export-data', exportData);
        }
    }
}();

module.exports = ExportData;
